import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Button, useMediaQuery, useTheme } from '@mui/material';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  const handleWhatsAppSupport = () => {
    window.open('https://wa.me/33652682350', '_blank');
  };

  return (
    <footer className="bg-white text-gray-700 border-t border-gray-200 mt-auto print:hidden">
      <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-between space-y-4">
          <div className="text-center">
            <p className="text-xs sm:text-sm">
              &copy; {currentYear} Football Coachs. Tous droits réservés.
            </p>
          </div>
          
          <div>
            <Button 
              variant="contained" 
              color="success" 
              startIcon={<WhatsAppIcon />}
              onClick={handleWhatsAppSupport}
              size={isMobile ? "medium" : "small"}
              fullWidth={isMobile}
              sx={{ 
                textTransform: 'none',
                backgroundColor: '#25D366',
                padding: isMobile ? '10px 16px' : '6px 16px',
                fontSize: isMobile ? '0.9rem' : '0.8rem',
                borderRadius: '8px',
                fontWeight: 500,
                '&:hover': {
                  backgroundColor: '#128C7E'
                }
              }}
            >
              Support
            </Button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
